import { useState, useCallback, useEffect } from 'react'

import { api } from 'app/api'
import { GET_REPORTS_DATA_ORDER_PURCHASES } from 'app/common/api/requests/reports/data'
import type { ReportsDataOrderPurchasesResult } from 'app/common/api/requests/reports/data.orders_purchases'

import { ordersPurchasesConvert, OrdersPurchases } from './ordersPurchasesConvert'


const defaultState: OrdersPurchases = {
  purchases: [],
  groups: { names: [], classes: [], countsByClass: {}, totals: [] },
  from: null,
  to: null,
}

export default function useOOPGenerateItems(reportId: number | null) {
  const [data, setData] = useState<OrdersPurchases>(defaultState)
  const [loading, setLoading] = useState(false)

  const requestItems = useCallback(async () => {
    if (!reportId) return

    setLoading(true)
    const res: ReportsDataOrderPurchasesResult | null = await api.request(GET_REPORTS_DATA_ORDER_PURCHASES, {
      error: 'Не удалось загрузить данные отчета',
      params: {
        report_id: reportId,
      },
    })

    if (res) {
      setData(ordersPurchasesConvert(res))
    }
    setLoading(false)
  }, [reportId])


  useEffect(() => {
    requestItems()
  }, [requestItems])

  return { data, loading }
}
